
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import './Tablemenu.css';

import { ShoppingCartIcon } from './Icons';
import { useWallet } from './useWallet';
import { useCart } from './useCart';
import { useFilters } from './useFilters';
import { useBookings } from './useBookings';
import CategoryList from './CategoryList';
import FilterBar from './FilterBar';
import DishCard from './DishCard';
import GSTPopup from './GSTPopup';
import ScheduleModal from './ScheduleModal';
import CartSidebar from './CartSidebar';

import Dineoutinvoice from './Dineoutinvoice'
import Vendorbanner from '../Tablemenu/Vendorbanner'

const MenuitemsTable = ({ setShowLogin }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [seatingContext, setSeatingContext] = useState(null);
  const [isFromAddItem, setIsFromAddItem] = useState(false);
  const [allDishes, setAllDishes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [description, setDescription] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [favorites, setFavorites] = useState([]);
  const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [gstTotal, setGstTotal] = useState(0);
  const [serviceCharges, setServiceCharges] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [tableCode, setTableCode] = useState("");
  const [notes, setNotes] = useState({});
  const [allReady, setAllReady] = useState(false);
  const [cartId, setCartId] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(false);
  const [couponId, setCouponId] = useState(null);
  const [showGstPopup, setShowGstPopup] = useState(false);
  const [gstBreakdownData, setGstBreakdownData] = useState(null);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedWalletType, setSelectedWalletType] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [orderPlacing, setOrderPlacing] = useState(false);
  const [showPaymentData, setShowPaymentData] = useState(false);
  const [serviceApplied, setServiceApplied] = useState(true);
  const [currentSeatingId, setCurrentSeatingId] = useState(null);
  const [isWalletChecked, setIsWalletChecked] = useState(false);
  const [isCashChecked, setIsCashChecked] = useState(false);
  const [isOnlineChecked, setIsOnlineChecked] = useState(false);
  const [showWalletOptions, setShowWalletOptions] = useState(false);
  const [loadingItems, setLoadingItems] = useState({});
  const [userProfile, setUserProfile] = useState(null);
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);

  const getItemKey = (item) => item?.cartItemId ?? item?.itemId;

  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const { availableBalance, availableSelf, availableCompany, availableCashback, fetchWalletData } = useWallet();
  const { cartLoading, quantities, setQuantities, removeCartItem, incrementQuantity, decrementQuantity, } = useCart();

  const [sentItems, setSentItems] = useState(() => {
    const saved = localStorage.getItem("sentItems");
    return saved ? JSON.parse(saved) : {};
  });
  const {
    isVegSelected,
    setIsVegSelected,
    isNonVegSelected,
    setIsNonVegSelected,
    searchTerm,
    setSearchTerm,
    filteredDishes,
    clearFilters,
    selectedCategory,
    setSelectedCategory
  } = useFilters(allDishes, categories);
  const bookings = useBookings();

  const getAuthVars = () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const vendorId = localStorage.getItem("vendorId");
    return { userId, token, vendorId };
  };


  const walletTypesMap = {
    self: "SELF_LOADED",
    company: "COMPANY_LOADED",
    cashback: "CASHBACK"
  };

  const buildCategoryTree = (data) => {
    const map = new Map();
    data.forEach((item) => {
      const isParent = !item.parentId || item.parentId === 0;
      if (isParent) {
        map.set(item.dishId, { ...item, subCategories: [] });
      }
    });
    data.forEach((item) => {
      const isChild = item.parentId && item.parentId !== 0;
      if (isChild && map.has(Number(item.parentId))) {
        map.get(Number(item.parentId)).subCategories.push(item);
      }
    });
    return Array.from(map.values());
  };

  const handleCategorySelect = (cat) => {
    setSelectedCategory(cat.dishId);
    setIsVegSelected(false);
    setIsNonVegSelected(false);
  };


  const handleSendToChef = async (item, setLoadingItems) => {
    const itemId = getItemKey(item);

    try {
      // 🔥 prevent double click
      setLoadingItems(prev => ({ ...prev, [itemId]: true }));

      const token = localStorage.getItem("authToken");

      if (!token) {
        alert("User not logged in ❌");
        return;
      }

      const note = notes[itemId] || "";
      const status = "CONFIRMED";

      const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}`;

      const res = await axios.put(
        url,
        null,
        {
          params: {
            status,
            note,
            quantity: item.quantity ?? 1
          },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      console.log("✅ Sent to Chef:", res.data);

      // ✅ success alert
      alert("Item Sent to Chef Successfully ✅");

      // ✅ mark sent
      setSentItems?.(prev => {
        const updated = { ...prev };
        delete updated[itemId];
        localStorage.setItem("sentItems", JSON.stringify(updated));
        return updated;
      });

      fetchCartDetails();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      alert("Failed ❌");
    } finally {
      setLoadingItems(prev => ({ ...prev, [itemId]: false }));
    }
  };


  const fetchInvoiceData = async (orderId, cartIdLocal, userId, token) => {
    try {
      // Fetch order details from backend
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const order = response.data;

      // Format invoice data
      const invoice = {
        orderId: order.orderId || orderId,
        date: new Date().toLocaleDateString('en-IN'),
        time: new Date().toLocaleTimeString('en-IN'),
        userName: order.userName || localStorage.getItem("userName") || "Guest",
        orderType: "DINE IN",
        order: order.items || [],
        subTotal: order.subTotal || 0,
        cgst: order.cgst || 2.5,
        sgst: order.sgst || 2.5,
        packingCharges: order.packingCharges || 0,
        deliveryCharges: order.deliveryCharges || 0,
        discountAmount: order.discountAmount || 0,
        totalAmount: order.totalAmount || order.grandTotal || 0,
        paymentMethod: "Online Payment",
        transactionId: order.razorpayPaymentId || order.transactionId,
        status: "COMPLETED",
        vendorRegisteredName: order.vendorName || "NAME",
        vendorFullAddress: order.vendorAddress || "",
        vendorPhone: order.vendorPhone || "",
        vendorGstIn: order.vendorGst || ""
      };

      setInvoiceData(invoice);
      setShowInvoice(true);

    } catch (error) {
      console.error("Error fetching invoice:", error);
      // Fallback: Create basic invoice from available data
      setInvoiceData({
        orderId: orderId,
        date: new Date().toLocaleDateString('en-IN'),
        time: new Date().toLocaleTimeString('en-IN'),
        userName: localStorage.getItem("userName") || "Guest",
        orderType: " TABLE_DINE_IN",
        order: cartItems.map(item => ({
          name: item.dishName || item.name,
          quantity: item.quantity,
          price: item.price || item.price
        })),
        subTotal: subTotal,
        cgst: 2.5,
        sgst: 2.5,
        totalAmount: grandTotal,
        paymentMethod: "Online Payment",
        status: "COMPLETED",
        vendorRegisteredName: "MAAMAAS"
      });
      setShowInvoice(true);
    }
  };




  const fetchCartDetails = useCallback(async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    if (!userId) return;

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/cart/get/user/with-seating?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      const cartData = response.data;

      let items = [];
      let cart = null;

      if (Array.isArray(cartData) && cartData.length > 0) {
        cart = cartData[0];
        items = cart.cartItems || [];

        // ✅ CART ID
        if (cart.cartId) {
          setCartId(cart.cartId);
          localStorage.setItem("cartId", cart.cartId);
        }

        // 🚨 FIX: seatingId ONLY update if valid number
        if (cart.seatingId && cart.seatingId !== 0) {
          console.log("🔥 Cart seatingId from backend:", cart.seatingId);

          setCurrentSeatingId(Number(cart.seatingId));
          localStorage.setItem("seatingId", cart.seatingId);
        }

        if (cart.tableCode) {
          setTableCode(cart.tableCode);
          localStorage.setItem("tableCode", cart.tableCode);
        }
      }

      setCartItems(items);

      const initialQuantities = {};
      items.forEach(item => {
        const itemId = item.itemId || item.cartItemId;
        if (itemId) initialQuantities[itemId] = item.quantity || 1;
      });

      setQuantities(initialQuantities);
      calculateTotals(items);

    } catch (error) {
      console.error("Error fetching cart:", error.response?.data || error.message);
      setCartItems([]);
    }
  }, []);

  const calculateTotals = useCallback((items) => {
    let sub = 0;
    items.forEach(item => {
      const price = parseFloat(item.price) || parseFloat(item.price) || 0;
      const qty = item.quantity || 1;
      sub += price * qty;
    });
    setSubTotal(sub);
    const gst = sub * 0.05;
    setGstTotal(gst);
    const service = sub * 0.1;
    setServiceCharges(service);
    const total = sub + gst + (serviceApplied ? service : 0) - discountAmount;
    setGrandTotal(total);
    const allItemsReady =
      items.length > 0 &&
      items.every(
        item =>
          item.orderStatus === "CONFIRMED" ||
          item.orderStatus === "COMPLETED"
      );

    setAllReady(allItemsReady);
  }, [serviceApplied, discountAmount]);

  useEffect(() => {
    const state = location.state;
    if (state && state.seatingId) {
      setIsFromAddItem(true);
      setSeatingContext(state);
      setCurrentSeatingId(state.seatingId);
      setTableCode(state.tableCode || "");
    } else {
      setIsFromAddItem(false);
      setSeatingContext(null);
      setCurrentSeatingId(null);
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setIsCartPanelOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      const userId = localStorage.getItem("userId");
      const vendorId = localStorage.getItem("vendorId");

      if (!userId || !vendorId) return;

      setCategoriesLoading(true);

      try {
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`
        );

        const data = Array.isArray(response.data) ? response.data : [];
        setCategories(buildCategoryTree(data));
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const { token, userId } = getAuthVars();
      const vendorId = localStorage.getItem("vendorId");
      if (!vendorId || !token || !userId) {
        setError(new Error("Missing required data"));
        setLoading(false);
        return;
      }
      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`,
          { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
        );
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setAllDishes(Array.isArray(data) ? data : data.data || []);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    fetchCartDetails();
    fetchWalletData();
  }, [fetchCartDetails, fetchWalletData]);

  useEffect(() => {
    if (cartItems.length > 0) calculateTotals(cartItems);
  }, [cartItems, calculateTotals]);

  const handleAddToFavorites = async (dishId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    if (!userId || !token) { toast.error("Please log in first."); return; }
    if (favorites.includes(dishId)) { toast.info("Already in favorites!"); return; }
    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`,
        { method: "POST", headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok || response.status === 409) {
        setFavorites(prev => [...new Set([...prev, dishId])]);
        toast.success("Added to favorites!");
      }
    } catch {
      toast.error("Network error.");
    }
  };

  const handleClearCart = async () => {
    const { userId, token } = getAuthVars();
    if (!userId) { toast.error("User ID not found!"); return; }
    try {
      const response = await axios.delete(
        `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        toast.success("Cart cleared!");
        setCartItems([]);
        setQuantities({});
        setGrandTotal(0); setSubTotal(0); setGstTotal(0);
        setDiscountAmount(0); setAppliedCoupon(false); setCouponId(null);
        setShowPaymentOptions(false); setSelectedPaymentMethod(null);
        localStorage.removeItem("cartId");
        await fetchCartDetails();
      }
    } catch {
      toast.error("Failed to clear cart");
    }
  };

  const toggleServiceCharges = async () => {
    const cartIdLocal = localStorage.getItem("cartId");
    const token = localStorage.getItem("authToken");
    const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
    try {
      await axios.put(
        `https://backend.maamaas.com/food/api/cart/coupon/${cartIdLocal}`,
        { serviceCharge: newStatus },
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      setServiceApplied(!serviceApplied);
      toast.success(`Service charges ${serviceApplied ? "removed" : "applied"}`);
      await fetchCartDetails();
    } catch {
      toast.error("Failed to update service charges");
    }
  };

  const handleShowGST = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      const gstObj = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : {};
      setGstBreakdownData({
        serviceChargeGst: gstObj.serviceChargeGst ?? 0,
        platformChargeGst: gstObj.platformChargeGst ?? 0,
        cgst: gstObj.cgst ?? 0,
        sgst: gstObj.sgst ?? 0,
      });
      setShowGstPopup(true);
    } catch {
      toast.error("Failed to fetch GST details");
    }
  };



  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;

      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };
  const calculateBackendAmount = () => {
    const cart = cartItems; // already from backend

    let total = 0;

    cart.forEach(item => {
      const price = Number(item.price || item.price || 0);
      const qty = Number(item.quantity || 1);
      total += price * qty;
    });

    return Number(total.toFixed(2));
  };

  const getFinalCartAmount = async (cartId, token, userId) => {
    const res = await axios.get(
      `https://backend.maamaas.com/food/api/cart/get/user/with-seating?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const cart = res.data?.[0];
    return {
      amount: cart?.grandTotal || 0,
      cart: cart
    };
  };

  const getFinalAmount = async (userId, token) => {
    const res = await axios.get(
      `https://backend.maamaas.com/food/api/cart/get/user/with-seating?userId=${userId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const cart = res.data?.[0];

    const amount = Number(cart?.grandTotal || 0);

    return amount; // ✅ ONLY NUMBER
  };



  const handlePayNow = async () => {
    if (!selectedPaymentMethod) {
      toast.error("Select payment method");
      return;
    }

    if (!allReady) {
      toast.error("Send all items to chef first");
      return;
    }

    // 🔥 ROUTING LOGIC
    if (selectedPaymentMethod === "Maamaas_Wallet") {
      await handleWalletPayment();
      return;
    }

    if (selectedPaymentMethod === "Online_Payment") {
      await handleCheckoutClick();
      return;
    }

    if (selectedPaymentMethod === "Cash") {
      // await handleCashPayment();
      return;
    }

    toast.error("Invalid payment method");
  };


  const handleCheckoutClick = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const cartIdLocal = cartId || localStorage.getItem("cartId");

    setOrderPlacing(true);

    try {
      const loaded = await loadRazorpayScript();
      if (!loaded) {
        toast.error("Razorpay failed to load");
        return;
      }

      const amount = await getFinalAmount(userId, token);
      const amountInPaise = (grandTotal);

      const orderRes = await axios.post(
        "https://backend.maamaas.com/food/api/payments/create-order/user",
        {
          amount: amountInPaise,
          currency: "INR",
          receipt: `order_${Date.now()}`,
          userId: parseInt(userId),
          cartId: cartIdLocal
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      const orderId = orderRes.data?.orderId || orderRes.data?.id;

      const options = {
        key: "rzp_live_RU5whSMu9rPV7s",
        amount: amountInPaise,
        currency: "INR",
        name: "Maamaas",
        description: `Pay ₹${amount}`,
        order_id: orderId,

        handler: async (response) => {
          try {
            const orderResponse = await axios.post(
              `https://backend.maamaas.com/food/api/orders/orders/create/${cartIdLocal}`,
              null,
              {
                params: {
                  userId: parseInt(userId),
                  paymentMethod: "Online_Payment",
                  amount,
                  razorpayPaymentId: response.razorpay_payment_id,
                  razorpayOrderId: response.razorpay_order_id
                },
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }
            );

            const newOrderId = orderResponse.data.orderId || orderResponse.data.id;

            toast.success("🎉 Payment Successful!");

            // 🔥 SET PAYMENT SUCCESS STATE
            setIsPaymentSuccessful(true);

            // Save payment status to localStorage to persist across refreshes
            localStorage.setItem("paymentSuccess", "true");
            localStorage.setItem("lastOrderId", newOrderId);
            await fetchInvoiceData(newOrderId, cartIdLocal, token);

            setCartItems([]);
            setGrandTotal(0);

            localStorage.removeItem("cartId");
            localStorage.removeItem("sentItems");

            // ✅ Redirect with full page refresh
            window.location.href = "/Newnearbyresturent";

            await fetchInvoiceData(newOrderId, cartIdLocal, userId, token);

            setCartItems([]);
            setGrandTotal(0);
            localStorage.removeItem("cartId");

            // Clear sent items
            localStorage.removeItem("sentItems");

          } catch (err) {
            toast.error("Order failed after payment");
          }
        },

        prefill: {
          name: "User",
          email: "test@test.com",
          contact: "9999999999"
        },

        theme: { color: "#3399cc" }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(err);
      toast.error("Checkout failed");
    } finally {
      setOrderPlacing(false);
    }
  };


  const handleWalletPayment = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const cartIdLocal = cartId || localStorage.getItem("cartId");

    setOrderPlacing(true);

    try {
      const amount = await getFinalAmount(userId, token);

      const mappedwalletTypes = walletTypesMap?.[selectedWalletType];

      if (!selectedWalletType || !mappedwalletTypes) {
        toast.error("Select wallet type");
        return;
      }

      const paymentRes = await axios.post(
        "https://backend.maamaas.com/food/api/payments/create-order/user",
        {
          userId: parseInt(userId),
          amount: amount,
          paymentMethod: "Maamaas_Wallet",
          walletType: mappedwalletTypes,
          cartId: cartIdLocal
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      const paymentOrderId = paymentRes.data?.orderId || paymentRes.data?.id;

      const orderResponse = await axios.post(
        `https://backend.maamaas.com/food/api/orders/orders/create/${cartIdLocal}`,
        null,
        {
          params: {
            userId: parseInt(userId),
            paymentMethod: "Maamaas_Wallet",
            walletTypes: mappedwalletTypes,
            amount: amount,
            razorpayPaymentId: paymentOrderId,
            razorpayOrderId: paymentOrderId
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const newOrderId = orderResponse.data?.orderId || orderResponse.data?.id;

      toast.success("🎉 Wallet Payment Successful!");

      // 🔥 SET PAYMENT SUCCESS STATE
      setIsPaymentSuccessful(true);
      localStorage.setItem("paymentSuccess", "true");
      localStorage.setItem("lastOrderId", newOrderId);

      await fetchInvoiceData(newOrderId, cartIdLocal,  token);

      setCartItems([]);
      setGrandTotal(0);

      localStorage.removeItem("cartId");
      localStorage.removeItem("sentItems");

      // ✅ Redirect with full page refresh
      window.location.href = "/Newnearbyresturent";

    } catch (err) {
      console.error("Wallet Error:", err?.response?.data || err);
      toast.error("Wallet payment failed");
    } finally {
      setOrderPlacing(false);
    }
  };

  // Add useEffect to check payment status on component mount
  useEffect(() => {
    const paymentSuccess = localStorage.getItem("paymentSuccess");
    if (paymentSuccess === "true") {
      setIsPaymentSuccessful(true);
    }
  }, []);

  // Add function to reset payment state for new order
  const resetForNewOrder = () => {
    setIsPaymentSuccessful(false);
    localStorage.removeItem("paymentSuccess");
    localStorage.removeItem("lastOrderId");
    // Clear cart and other states
    setCartItems([]);
    setQuantities({});
    setShowPaymentOptions(false);
    setSelectedPaymentMethod(null);
  };


  const handleOpenRazorpay = (
    orderData,
    userId,
    cartIdLocal,
    token,
    amount,
    amountInPaise
  ) => {
    const options = {
      key: "rzp_live_RU5whSMu9rPV7s",

      amount: amountInPaise,
      currency: "INR",

      name: "Maamaas",
      description: `Pay ₹${amount} for Cart ${cartIdLocal}`,

      // ⚠️ correct field
      order_id: orderData.id || orderData.orderId,

      handler: async function (response) {
        try {
          await axios.post(
            `https://backend.maamaas.com/food/api/orders/orders/create/${cartIdLocal}`,
            null,
            {
              params: {
                userId: parseInt(userId),
                paymentMethod: "Online_Payment",
                amount: amount,   // 🔥 MUST MATCH BACKEND
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          );

          toast.success("Order placed successfully 🎉");
        } catch (err) {
          console.error("Final Order Error:", err.response?.data);
          toast.error("Order failed after payment ❌");
        }
      },

      prefill: {
        name: userProfile?.name || "",
        email: userProfile?.email || "",
        contact: userProfile?.phoneNumber || ""
      },

      theme: {
        color: "#3399cc"
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleCheckboxChange = (method, isChecked) => {
    if (isChecked) {
      setIsWalletChecked(method === "wallet");
      setIsCashChecked(method === "cash");
      setIsOnlineChecked(method === "online");

      if (method === "wallet") {
        setSelectedPaymentMethod("Maamaas_Wallet");
        setShowWalletOptions(true);
      }
      else if (method === "cash") {
        setSelectedPaymentMethod("Cash");
        setShowWalletOptions(false);
      }
      else if (method === "online") {
        setSelectedPaymentMethod("Online_Payment");
        setShowWalletOptions(false);
      }
      else {
        setSelectedPaymentMethod(null); // 🔥 NO DEFAULT ONLINE
      }

    } else if (method === "wallet") {
      setIsWalletChecked(false);
      setShowWalletOptions(false);
      setSelectedPaymentMethod(null);
    }
  };

  const getTotalItems = () => cartItems.reduce((t, i) => t + (i.quantity || 1), 0);
  const cartItemsCount = getTotalItems();

  const handleAddToCart = (dish) => {
    const seatingId = Number(currentSeatingId);

    console.log("🔥 FINAL seatingId:", seatingId);

    if (!seatingId || seatingId === 62) {
      toast.error("Invalid seating session ❌ (62 blocked)");
      return;
    }

    addToCart(dish, 1, seatingId, fetchCartDetails);
  };

  const addToCart = async (
    dish,
    quantity = 1,
    seatingId,
    fetchCartDetails
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) {
        toast.error("User not logged in ❌");
        return;
      }

      if (!dish?.dishId) {
        console.error("❌ dishId missing", dish);
        return;
      }

      // ✅ Correct API URL
      const url =
        "https://backend.maamaas.com/food/api/cart/add/table/cart/add-item";

      // ✅ API expects ARRAY
      const payload = [
        {
          dishId: Number(dish.dishId),
          quantity: Number(quantity),
        },
      ];

      console.log("📦 Payload:", payload);
      console.log("🪑 seatingId:", seatingId);

      const res = await axios.post(url, payload, {
        params: {
          userId: Number(userId),
          seatingId: Number(seatingId),
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("✅ Item Added:", res.data);

      toast.success("Added to Cart 🛒");

      // ✅ Refresh cart
      if (fetchCartDetails) {
        fetchCartDetails();
      }
    } catch (err) {
      console.error(
        "❌ Add to Cart Error:",
        err.response?.data || err.message
      );

      toast.error(
        err.response?.data?.message || "Failed to add item ❌"
      );
    }
  };

  const resetSentStatus = (itemId) => {
    setSentItems(prev => {
      const updated = { ...prev };
      delete updated[itemId];
      localStorage.setItem("sentItems", JSON.stringify(updated));
      return updated;
    });
  };


  const handleIncrementQuantity = (item) => {
    const itemId = getItemKey(item);

    if (!item || !itemId) return; // ✅ safety

    // 👉 first update quantity
    incrementQuantity(item);

    // 👉 then reset sent state
    setSentItems(prev => {
      if (!prev) return {}; // extra safety

      const updated = { ...prev };

      if (updated[itemId]) {
        delete updated[itemId];
        localStorage.setItem("sentItems", JSON.stringify(updated));
      }

      return updated;
    });
  };
  const handleDecrementQuantity = (item) => {
    const itemId = getItemKey(item);

    if (!item || !itemId) return; // ✅ safety

    // 👉 first update quantity
    decrementQuantity(item);

    // 👉 then reset sent state
    setSentItems(prev => {
      if (!prev) return {}; // extra safety

      const updated = { ...prev };

      if (updated[itemId]) {
        delete updated[itemId];
        localStorage.setItem("sentItems", JSON.stringify(updated));
      }

      return updated;
    });
  };

  // const handleSendToChefWrapper = (item) => handleSendToChef(item, quantities, fetchCartDetails);

  const handleDeleteItem = async (item) => {
    const { userId, token } = getAuthVars();
    const itemId = item?.cartItemId ?? item?.itemId;

    if (!userId || !itemId) return;

    try {
      await axios.delete(
        `https://backend.maamaas.com/food/api/cart/items/${itemId}`,
        {
          params: { userId },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success("Item removed 🗑");

      // 🔥 SAFE UPDATE (IMPORTANT FIX)
      setCartItems(prev => {
        const updated = prev.filter(
          i => (i.cartItemId ?? i.itemId) !== itemId
        );

        console.log("UPDATED CART:", updated);
        return updated;
      });

      // 🔥 optional but important for mobile sync
      setTimeout(() => {
        fetchCartDetails?.();
      }, 300);

    } catch (err) {
      console.error("DELETE ERROR:", err.response?.data || err.message);
      toast.error("Delete failed");
    }
  };


  useEffect(() => {
    const hasPending = cartItems.some(
      item => item.status?.trim().toUpperCase() !== "DELIVERED"
    );

    if (!hasPending) return; // ✅ sab delivered → stop refresh

    const interval = setInterval(() => {
      console.log("🔄 Auto refreshing (pending items)...");
      fetchCartDetails();
    }, 5000);

    return () => clearInterval(interval);
  }, [cartItems]);


  if (loading) return (
    <div className="menu-loading">
      <div className="menu-loading-spinner" />
      <span>Loading Menu...</span>
    </div>
  );
  if (error) return <div className="menu-error">Error: {error.message}</div>;

  return (
    <div className="menu-page-wrapper">
      <div className="menu-content">
        {isFromAddItem && seatingContext && (
          <div className="menu-table-banner">
            <div>
              <span className="menu-table-name">🍽️ Table: {seatingContext.tableCode}</span>
              <span className="menu-table-guest">👤 {seatingContext.guestName}</span>
            </div>
            {/* <button className="menu-view-bookings-btn" onClick={() => navigate('/Myordermain')}>
                            View Bookings →
                        </button> */}
            <button
              className="menu-view-bookings-btn"
              onClick={() => {

                // ✅ USE NAVIGATE STATE - Most reliable method
                navigate('/Myordermain', {
                  state: { activeTab: 3 }  // Send as number directly
                });

                console.log("Navigating with state: activeTab = 3");
              }}
            >
              View My Bookings
            </button>
          </div>
        )}
        <div className="vendor-banner-wrapper">
          <Vendorbanner />
        </div>

        <FilterBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isVegSelected={isVegSelected}
          setIsVegSelected={setIsVegSelected}
          isNonVegSelected={isNonVegSelected}
          setIsNonVegSelected={setIsNonVegSelected}
          selectedCategory={selectedCategory}
          clearFilters={clearFilters}
          openScheduleModal={bookings.openScheduleModal}
        />



        <CategoryList
          categories={categories}
          categoriesLoading={categoriesLoading}
          selectedCategory={selectedCategory}
          onCategoryClick={handleCategorySelect}
        />


        <div className="menu-dishes-grid">
          {filteredDishes.map(item => (
            <DishCard
              key={item.dishId}
              item={item}
              favorites={favorites}
              handleAddToFavorites={handleAddToFavorites}
              activeTooltip={activeTooltip}
              setActiveTooltip={setActiveTooltip}
              description={description}
              setDescription={setDescription}
              addToCart={handleAddToCart}
              cartLoading={cartLoading}
              isFromAddItem={isFromAddItem}
              currentSeatingId={currentSeatingId}
              openScheduleModal={bookings.openScheduleModal}
            />
          ))}
        </div>
      </div>

      {!isMobile && (
        <div className="cart-desktop-wrapper">
          <CartSidebar
            isMobileView={true}
            cartItemsCount={cartItemsCount}
            cartItems={cartItems}
            handleClearCart={handleClearCart}
            tableCode={tableCode}
            currentSeatingId={currentSeatingId}
            openScheduleModal={bookings.openScheduleModal}
            showPaymentData={showPaymentData}
            orderId={orderId}
            setShowPaymentData={setShowPaymentData}
            fetchCartDetails={fetchCartDetails}
            incrementQuantity={handleIncrementQuantity}
            decrementQuantity={handleDecrementQuantity}
            notes={notes}
            setNotes={setNotes}
            handleSendToChef={handleSendToChef}
            subTotal={subTotal}
            handleShowGST={handleShowGST}
            gstTotal={gstTotal}
            serviceApplied={serviceApplied}
            toggleServiceCharges={toggleServiceCharges}
            serviceCharges={serviceCharges}
            discountAmount={discountAmount}
            grandTotal={grandTotal}
            showPaymentOptions={showPaymentOptions}
            setShowPaymentOptions={setShowPaymentOptions}
            allReady={allReady}
            selectedPaymentMethod={selectedPaymentMethod}
            isWalletChecked={isWalletChecked}
            handleCheckboxChange={handleCheckboxChange}
            showWalletOptions={showWalletOptions}
            selectedWalletType={selectedWalletType}
            setSelectedWalletType={setSelectedWalletType}
            availableBalance={availableBalance}
            availableSelf={availableSelf}
            availableCompany={availableCompany}
            availableCashback={availableCashback}
            isCashChecked={isCashChecked}
            isOnlineChecked={isOnlineChecked}
            orderPlacing={orderPlacing}
            handleCheckoutClick={handleCheckoutClick}
            handleWalletPayment={handleWalletPayment}
            isMobileView={isMobile}
            handleDeleteItem={handleDeleteItem}
            sentItems={sentItems}
            setSentItems={setSentItems}

          />
        </div>
      )}

      {isMobile && !showPaymentData && (
        <button className="cart-fab" onClick={() => setIsCartPanelOpen(true)}>
          <ShoppingCartIcon />
          {cartItemsCount > 0 && <span className="cart-fab-badge">{cartItemsCount}</span>}
        </button>
      )}

      {isMobile && isCartPanelOpen && (
        <>
          <div className="cart-overlay" onClick={() => setIsCartPanelOpen(false)} />
          <CartSidebar
            isMobileView={true}
            sentItems={sentItems}
            onClose={() => setIsCartPanelOpen(false)}
            cartItemsCount={cartItemsCount}
            cartItems={cartItems}
            handleClearCart={handleClearCart}
            tableCode={tableCode}
            currentSeatingId={currentSeatingId}
            openScheduleModal={bookings.openScheduleModal}
            showPaymentData={showPaymentData}
            orderId={orderId}
            setShowPaymentData={setShowPaymentData}
            fetchCartDetails={fetchCartDetails}
            decrementQuantity={handleDecrementQuantity}
            incrementQuantity={handleIncrementQuantity}
            notes={notes}
            setNotes={setNotes}
            handleSendToChef={handleSendToChef}
            subTotal={subTotal}
            handleShowGST={handleShowGST}
            gstTotal={gstTotal}
            serviceApplied={serviceApplied}
            toggleServiceCharges={toggleServiceCharges}
            serviceCharges={serviceCharges}
            discountAmount={discountAmount}
            grandTotal={grandTotal}
            showPaymentOptions={showPaymentOptions}
            setShowPaymentOptions={setShowPaymentOptions}
            allReady={allReady}
            selectedPaymentMethod={selectedPaymentMethod}
            isWalletChecked={isWalletChecked}
            handleCheckboxChange={handleCheckboxChange}
            showWalletOptions={showWalletOptions}
            selectedWalletType={selectedWalletType}
            setSelectedWalletType={setSelectedWalletType}
            availableBalance={availableBalance}
            availableSelf={availableSelf}
            availableCompany={availableCompany}
            availableCashback={availableCashback}
            isCashChecked={isCashChecked}
            isOnlineChecked={isOnlineChecked}
            orderPlacing={orderPlacing}
            handleCheckoutClick={handleCheckoutClick}
          />
        </>
      )}
      <Dineoutinvoice
        isOpen={showInvoice}
        onClose={() => setShowInvoice(false)}
        orderData={invoiceData}
      />

      <GSTPopup
        showGstPopup={showGstPopup}
        setShowGstPopup={setShowGstPopup}
        gstBreakdownData={gstBreakdownData}
      />

      <ScheduleModal
        isScheduleModalOpen={bookings.isScheduleModalOpen}
        setIsScheduleModalOpen={bookings.setIsScheduleModalOpen}
        waitingListMessage={bookings.waitingListMessage}
        bookingSuccess={bookings.bookingSuccess}
        bookingDetails={bookings.bookingDetails}
        guestName={bookings.guestName}
        setGuestName={bookings.setGuestName}
        phoneNumber={bookings.phoneNumber}
        setPhoneNumber={bookings.setPhoneNumber}
        numberOfGuests={bookings.numberOfGuests}
        setNumberOfGuests={bookings.setNumberOfGuests}
        durationMinutes={bookings.durationMinutes}
        setDurationMinutes={bookings.setDurationMinutes}
        scheduleDate={bookings.scheduleDate}
        setScheduleDate={bookings.setScheduleDate}
        scheduleTime={bookings.scheduleTime}
        setScheduleTime={bookings.setScheduleTime}
        bookingLoading={bookings.bookingLoading}
        handleScheduleConfirm={bookings.handleScheduleConfirm}
      />
    </div>
  );
};

export default MenuitemsTable;